import Vuex from "vuex";
import Vue from "vue";
import default_mutations from "./mutations";
import default_state from "./state";
import default_actions from "./actions";

Vue.use(Vuex);

/**
 * Merging given store config with default one.
 */ 
class StoreCreator
{
    /**
     * Defining config.
     * @param {Object} config
     * @param {Object<string, any>} config.state
     * @param {Object<string, Function} config.mutations
     * @param {Object<string, Function} config.actions
     * @param {Object<string, Function} config.getters
     * @param {Object<string, Function} config.actions
     */
    constructor(config)
    {
        this.config = config;
    }

    /** Merging state. */
    mergeState()
    {
        return {
            ...default_state,
            ...this.config.state
        }
    }
    
    /** Merging mutations. */
    mergeMutations()
    {
        return {
            ...default_mutations,
            ...this.config.mutations
        }
    }

    /** Merging actions. */
    mergeActions() {
        return {
            ...default_actions,
            ...this.config.actions
        }
    }
    
    /** Merging config and creating store. */
    merge()
    {
        const merged = {
            actions: this.mergeActions(),
            mutations: this.mergeMutations(),
            state: this.mergeState(),
            getters: this.config.getters
        }

        return new Vuex.Store(merged)
    }
}

export default StoreCreator;